import type React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { routes } from '@vlabs/shared/navigation/routes';
import { Control } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

interface ShowEventsByFaceIdLinkPoint3Props extends WithDataTestid {
  faceId: string;
  className?: string;
}

function ShowEventsByFaceIdLinkPoint3({
  faceId,
  className = undefined,
  'data-testid': dataTestId = 'showEventsByFaceLink',
  ...linkProps
}: ShowEventsByFaceIdLinkPoint3Props): React.JSX.Element {
  const { t } = useTranslation();
  const title = t('monokit:features.show events by face id link.title');
  const searchParams = new URLSearchParams({ top_similar_object_ids: faceId });

  return (
    <Control.Link
      className={className}
      data-testid={dataTestId}
      icon={<ArrowInCircleRightIcon />}
      kind="primary"
      size="medium"
      title={title}
      to={`${generatePath((routes.events as { archive: string }).archive)}?${searchParams.toString()}`}
      {...linkProps}
    >
      {title}
    </Control.Link>
  );
}

export { ShowEventsByFaceIdLinkPoint3 };
